/* Midnight Atelier — homepage reveal-on-scroll.
   Adds .is-visible to .ma-reveal elements as they enter the viewport.
   No-JS / unsupported / reduced-motion: elements are shown immediately
   (CSS reduced-motion rule also forces them visible). */
(function () {
  var els = document.querySelectorAll('.ma-reveal');
  if (!els.length) return;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  els.forEach(function (el) {
    io.observe(el);
  });

  // Safety net: if anything is still hidden after load (e.g. above-fold
  // elements the observer settled before paint), reveal them.
  window.addEventListener('load', function () {
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
    });
  });
})();

/* Midnight Atelier — simple slider (finishes strip).
   Shows 3 cards; arrows scroll one card at a time. Swipe still works.
   Progressive enhancement: without JS the track stays swipeable. */
(function () {
  var sliders = document.querySelectorAll('[data-ma-slider]');
  if (!sliders.length) return;

  sliders.forEach(function (root) {
    var track = root.querySelector('[data-ma-slider-track]');
    var prev = root.querySelector('[data-ma-slider-prev]');
    var next = root.querySelector('[data-ma-slider-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () { stopAuto(); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { stopAuto(); track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* Auto-advance once when the slider enters the viewport: step through
       the hidden cards to the end, then back to the start, then stop.
       Cancels on any user interaction. Skipped for reduced-motion. */
    var autoTimer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, stopAuto, { passive: true });
    });
    function startAuto() {
      if (reduce || autoTimer) return;
      if (track.scrollWidth <= track.clientWidth + 2) return; // nothing to reveal
      var goingForward = true;
      autoTimer = setInterval(function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if (goingForward && track.scrollLeft >= maxScroll) { goingForward = false; }
        if (!goingForward && track.scrollLeft <= 1) { stopAuto(); return; }
        track.scrollBy({ left: goingForward ? step() : -step(), behavior: 'smooth' });
      }, 1800);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { startAuto(); obs.disconnect(); }
        });
      }, { threshold: 0.4 });
      io.observe(root);
    }
  });
})();
